class Ratings extends DrupalBehavior {
  rating(selector, context) {
    const items = context.querySelectorAll(selector);

    if (items) {
      items.forEach((item) => {
        if (item.querySelector('.doctor-rating')) {

          const doctorRating = item.querySelector('.doctor-rating');
          const nid = doctorRating.getAttribute('data-rating');
          const starWrap = item.querySelector('.doctor-rating--stars');
          const starContainer = document.createElement('div');
          starContainer.classList.add('doctor-rating--stars-container');
          const overview = item.querySelector('.doctor-rating--description-overview');
          if (doctorRating && nid) {

            const data = drupalSettings.ratingData[nid];
            if (data && data.reviewCount >= 30) {
              doctorRating.classList.remove('no-rating');
              let ratingNumber = data.ratingValueStr;
              let ratingWrap = item.querySelector('.doctor-rating--description-number');
              ratingWrap.textContent = ratingNumber;
              // let ratingWidth = starWrap.offsetWidth;
              ratingWidth = 106;
              let ratingPercentage = Math.floor((ratingNumber / 5) * 100);
              starWrap.style.width = `${ratingWidth * (ratingPercentage * .01)}px`;
              starContainer.textContent = ratingNumber;
              if (overview) {
                overview.textContent = '(' + data.reviewCountStr + ')';
              }
            }
          }
          starWrap.appendChild(starContainer);
        }
      });
    }
  }

  onContent(context) {

    const doctorDetail = context.querySelector('.doctor');

    if (doctorDetail) {
      this.rating('.doctor-profile', context);
    }

    const doctorLanding = context.querySelector('.find-a-doctor');

    if (doctorLanding) {
      this.rating('.doctor-teaser', context);
    }

    const teamGroup = context.querySelector('.doctor-image-card');

    if (teamGroup) {
      this.rating('.doctor-image-card', context);
    }
  }
}

DrupalBehavior.register('summit_theme', 'ratings', Ratings);
